import { Injectable } from '@angular/core';
import { HttpHelperService } from '@core/services/http-helper.service';
import { ApiResponseMaileroo, MailerooService } from '@swagger/index';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MailerooWrapperService {
  constructor(
    private readonly mailerooService: MailerooService,
    private readonly httpHelperService: HttpHelperService
  ) {}

  public verifyEmailAddress(email: string): Observable<ApiResponseMaileroo> {
    const options = this.httpHelperService.getDefaultBypassLoadingOptions(true);

    return this.mailerooService.mailerooControllerVerifyEmail(email, undefined, undefined, options);
  }
}
